import { useState, useEffect } from "react";
import "../index.css";
import "../public/Login.css";
// import Footer from "../components/Footer";
// import { PageNav } from "../components/PageNav";
import { useAuth } from "../auth/context";
import { Navigate } from "react-router-dom";
import buttonBackground from "../assets/button_background_blue.webp";

export default function VerifyEmail() {
  const [error, setError] = useState<string>("");
  const [success, setSuccess] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [countdown, setCountdown] = useState<number>(0);
  const [isLoggingOut, setIsLoggingOut] = useState<boolean>(false);
  const { user, resendVerificationEmail, refreshUser, logout } = useAuth();

  // Check if user is verified on mount and periodically
  useEffect(() => {
    // Don't check if we're logging out
    if (isLoggingOut) return;

    const checkVerification = async () => {
      await refreshUser();
    };

    // Check immediately
    checkVerification();

    // Check every 5 seconds
    const interval = setInterval(checkVerification, 5000);

    return () => clearInterval(interval);
  }, [refreshUser, isLoggingOut]);

  // Countdown timer for resend button
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const handleResendEmail = async () => {
    setError("");
    setSuccess("");
    setIsLoading(true);

    try {
      await resendVerificationEmail();
      setSuccess("Verification email sent! Please check your inbox.");
      setCountdown(60); // 60 second cooldown
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Failed to send verification email");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCheckVerification = async () => {
    setError("");
    setIsLoading(true);

    try {
      await refreshUser();
      if (!user?.emailVerified) {
        setError(
          "Email not yet verified. Please check your inbox and click the verification link.",
        );
      }
    } catch {
      setError("Failed to check verification status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = async () => {
    setIsLoggingOut(true);
    await logout();
    // Navigation will happen automatically when user becomes null
  };

  // If no user (or logging out), redirect to login
  if (!user || isLoggingOut) {
    return <Navigate to="/login" replace />;
  }

  // If user is verified, redirect to tour
  if (user.emailVerified) {
    return <Navigate to="/tour" replace />;
  }

  return (
    <div>
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-overlay-spinner"></div>
        </div>
      )}
      {/* <PageNav /> */}
      <div className="form-container" style={{ marginTop: 100 }}>
        <div className="form-content">
          <div className="center_me">
            <h2
              className="font_family_base header_text"
              style={{
                fontSize: 28,
                fontWeight: "bold",
                margin: 0,
              }}
            >
              Verify Your Email
            </h2>
          </div>

          <div
            className="font_family_base"
            style={{
              textAlign: "center",
              marginTop: 20,
              marginBottom: 20,
              color: "#ccc",
              lineHeight: 1.6,
            }}
          >
            <p>We've sent a verification email to:</p>
            <p style={{ fontWeight: "bold", color: "#fff", fontSize: 18 }}>
              {user.email}
            </p>
            <p style={{ marginTop: 15 }}>
              Please click the link in the email to verify your account.
            </p>
          </div>

          <div
            style={{
              minHeight: "48px",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            {error && (
              <div
                className="font_family_base error_text_color"
                style={{
                  padding: "13px",
                  borderRadius: "8px",
                  textAlign: "center",
                  border: "1px solid #FF0000",
                }}
              >
                {error}
              </div>
            )}
            {success && (
              <div
                className="font_family_base"
                style={{
                  padding: "13px",
                  borderRadius: "8px",
                  textAlign: "center",
                  border: "1px solid #4ade80",
                  color: "#4ade80",
                }}
              >
                {success}
              </div>
            )}
          </div>

          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <button
              className="my-form-button-wide button-base button-3d font_family_base"
              onClick={handleCheckVerification}
              disabled={isLoading}
              style={{
                marginTop: "5px",
                marginBottom: "15px",
                backgroundImage: `url(${buttonBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                fontWeight: 700,
                width: "250px",
              }}
            >
              {isLoading ? (
                <div className="loading-spinner"></div>
              ) : (
                "I've Verified My Email"
              )}
            </button>
          </div>

          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <button
              className="my-form-button-wide button-base font_family_base background_1"
              onClick={handleResendEmail}
              disabled={isLoading || countdown > 0}
              style={{
                marginTop: "5px",
                marginBottom: "15px",
                color: "white",
                fontWeight: 700,
                opacity: countdown > 0 ? 0.6 : 1,
                width: "250px",
              }}
            >
              {countdown > 0
                ? `Resend Email (${countdown}s)`
                : "Resend Verification Email"}
            </button>
          </div>

          <button
            className="font_family_base link-text"
            onClick={handleLogout}
            type="button"
            style={{ marginTop: 20 }}
          >
            Use a different email? Sign out
          </button>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}
